import request from "@/utils/request";

/** 系统管理导出记录查询，服务端会再次校验超级管理员身份。 */
export function queryOutPutRecords(data) {
  return request({
    url: "/sys/outPut/admin/query",
    method: "post",
    data,
  });
}
